<!--
미도착 => 취소
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-auto">

            <div class="uk-modal-header">
                <h4>미도착 => 트래킹재입력</h4>
            </div>
            <div class="uk-modal-body uk-padding-small uk-text-center">
                미도착 상품의 트래킹을 다시 입력합니다.<br />
                (새로 입력할 트래킹으로 곧 도착할 예정인 경우)<br /><br />
                배송단계는 <b>벤더배송중</b>으로 변경됩니다.

                <div class="uk-margin-top uk-text-left">
                    <app-input-ex

                        type="text"
                        input-size="small"

                        v-model="trackingNo"
                        label="새 트래킹번호"

                        :validate-rules="{required: true}"
                        required
                        required-layout="label-left"

                        placeholder=""
                    > </app-input-ex>
                </div>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    트래킹재입력(완료)
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},

                // 트래킹입력
                trackingNo: null,
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param prod_id 상품ID
             */
            form(prod_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.prod = response.prod;
                    this.trackingNo = this.prod.tracking_no;

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/prods/' + this.prod.id + '/not-arrival-to-retracking',
                    data: {
                        '_token': this.csrfToken,
                        'tracking_no': this.trackingNo,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(() => {
                            $.app.move('/prods/'+this.prod.id);
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>